import { __assign } from "tslib";
import React, { useRef, useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { useIsOverflowed } from '@wix/da-hooks/pkg/useIsOverflowed';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { DEFAULT_COLLAPSED_HEIGHT } from '../../constants';
import s from './ExpandableWrapper.scss';
var NO_TOGGLE_HEIGHT_ADJUST = 32;
var ExpandableWrapper = function (_a) {
    var propsOverflowRef = _a.contentContainerRef, _b = _a.collapsedHeight, collapsedHeight = _b === void 0 ? DEFAULT_COLLAPSED_HEIGHT : _b, allowExpansion = _a.allowExpansion, forceShowToggle = _a.forceShowToggle, toggleButton = _a.toggleButton, toggleButtonHref = _a.toggleButtonHref, toggleButtonBiData = _a.toggleButtonBiData, toggleButtonContents = _a.toggleButtonContents, overflowCacheKey = _a.overflowCacheKey, onExpansion = _a.onExpansion, onOverflowMeasured = _a.onOverflowMeasured, children = _a.children;
    var defaultOverflowRef = useRef(null);
    var contentContainerRef = propsOverflowRef || defaultOverflowRef;
    var _c = useIsOverflowed(contentContainerRef, undefined, overflowCacheKey), isOverflowed = _c.isOverflowed, isOverflowMeasured = _c.isReady;
    useEffect(function () {
        isOverflowMeasured && onOverflowMeasured && onOverflowMeasured();
    }, [isOverflowMeasured, onOverflowMeasured]);
    var _d = useState(false), expanded = _d[0], setExpanded = _d[1];
    var toggleExpanded = useCallback(function (event) {
        event.preventDefault();
        setExpanded(function (value) {
            onExpansion && onExpansion(value);
            return !value;
        });
    }, [onExpansion]);
    var collapsedHeightLimit = toggleButtonContents
        ? collapsedHeight
        : collapsedHeight - NO_TOGGLE_HEIGHT_ADJUST;
    var isShowingToggleButton = (isOverflowed && !expanded) || forceShowToggle;
    return (React.createElement("div", __assign({ className: classnames(s['root'], !expanded && s['collapsed']) }, (!expanded && { style: { maxHeight: collapsedHeightLimit } })),
        React.createElement("div", { className: s['content'], ref: contentContainerRef }, children),
        isShowingToggleButton &&
            (toggleButton || (React.createElement(TextButton, { className: classnames(s['toggle-button'], !toggleButtonContents && s['no-button-text']), variant: "main", size: "medium", onClick: allowExpansion ? toggleExpanded : undefined, href: toggleButtonHref, isFakeButton: !allowExpansion && !toggleButtonHref, biData: toggleButtonBiData, noHorizontalPaddings: false },
                React.createElement("span", { className: s['toggle-button-contents'] }, toggleButtonContents))))));
};
ExpandableWrapper.displayName = 'ExpandableWrapper';
export default ExpandableWrapper;
//# sourceMappingURL=ExpandableWrapper.js.map